export default "__VITE_ASSET__BAYzXeph__"